import React from 'react';

import CommonStyles from '../CommonStyles';
import { makeStyles } from '@mui/styles';
import { Autocomplete, TextField, FormControl } from '@mui/material';

const useStyles = makeStyles(() => ({
  paper: {
    left: 0,
    right: 0,
    zIndex: 999,
    fontSize: 12,
    overflowY: 'hidden',
    background: '#fff',
    position: 'absolute',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  },
  list: {
    '& .MuiAutocomplete-option': {
      //background: '#FFFF',
      '&:hover': {
        background: '#eeecf8',
      },
      '&:focused': {
        background: '#DBD9E7',
      },
    },
    boxShadow: '0 5px 5px -3px rgba(0,0,0,0.2)',
    '&::-webkit-scrollbar': {
      width: '3px',
      background: 'rgba(0,0,0, 0.2)',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
      background: '#BCBCBC',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#878787',
      borderRadius: '10px',
    },
  },
  autocompleteRoot: {
    '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
      height: '23px !important',
      padding: '2px 4px 2px 5px !important',
      boxSizing: 'border-box !important',
      lineHeight: '1.2 !important',
      background: 'transparent',
    },
    '& .MuiOutlinedInput-root .MuiAutocomplete-root': {
    },
    '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
      right: '2px',
    },
    '& .MuiOutlinedInput-root': {
      padding: '0px',
      '&:focus': {
        background: '#D9D8ED', //'#DBD9E7 !important',
      },
    },
  },
  inputField: {
    "&::before": { display: "none" },
    "&::after": { display: "none" },
  },
  ...CommonStyles,
}));

export default(
  ({
    type,
    value,
    indKey,
    values,
    freeSolo,
    disabled,
    onChange,
    fullWidth,
    selectClasses,
  }) => {
    const classes = useStyles();

    return (
    <FormControl
      fullWidth
      disabled={disabled}
    >
      <Autocomplete
        autoComplete
        includeInputInList
        disabled={disabled}
        freeSolo={freeSolo}
        forcePopupIcon={true}
        classes={{ paper: `${classes.paper}`, listbox: classes.list, root: classes.autocompleteRoot }}
        onChange={(e, newValue) => {
          if (newValue) {
            onChange(newValue);
          } else {
            onChange('');
          }
        }}
        defaultValue={values.find(val => val === value) || ''}
        inputValue={value || ''}
        onInputChange={(e, newInputValue) => {
          if (e) //to prevent inserting empty val on component load
          if (newInputValue) {
            onChange(newInputValue);
          } else {
            onChange('');
          }
        }}
        id={`${indKey}_autocomlete select`}
        options={values}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              className: `${classes.inputField} ${selectClasses.root}`,
            }}
            readOnly={disabled}
            fullWidth={fullWidth}
            margin="none"
            minRows={1}
            type={type}
          />
        )
      }
      />
    </FormControl>
    )
  }
);
